import { createMuiTheme } from '@material-ui/core/styles';
import { AlertClassKey } from '@material-ui/lab/Alert';
declare module '@material-ui/core/styles/overrides' {
    export interface ComponentNameToClassKey {
        MuiAlert: AlertClassKey;
    }
}

const theme = createMuiTheme({
    palette: {

        primary: {
            light: '#5174d5',
            main: '#0049a3',
            dark: '#002373',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#DBDBDB',
        },

    },
    typography: {
        fontFamily: "'Lato', sans-serif;",
        fontSize: 18,

        button: {
            textTransform: "none",
            fontWeight: "normal",
        },
        h1: {
            fontSize: 36,
        },

    },
    overrides: {
        MuiTableCell: {
            root: {
                paddingLeft: 40
            },
            head: {
                fontWeight: 'bold',
                borderBottom: '1px solid #979797',
            }
        },
        MuiButton: {

            root: {
                borderRadius: 5,
                fontSize: 18,
                minWidth: 163,
                fontWeight: 'bold',

            },
            contained: {
                fontSize: 18,
                height: 43,
                boxShadow: 'none',
                '&:hover': {
                    boxShadow: 'none',
                },
            },
            text: {
                padding: '6px 24px',
            },
            textPrimary: {
                color: '#fff',
                backgroundColor: '#02489D',
                '&:hover': {
                    color: '#fff',
                    backgroundColor: '#02489D',
                }
            },
            textSecondary: {
                color: '#333',
                backgroundColor: '#DBDBDB',
                '&:hover': {
                    color: '#333',
                    backgroundColor: '#DBDBDB',
                }
            }


        },
        MuiTextField: {
            root: {
                width: '100%',
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    border: "none"
                },
            },

        },
        MuiOutlinedInput: {
            root: {
                backgroundColor: '#ECECEC',
                color: 'black',
                height: '40px',
                borderRadius: '6px',
                border: 'none',
                
            },
            notchedOutline: {
                border: 'none'
            }

        },

        MuiMenuItem: {
            root: {
                fontSize: 18
            }
        },
        MuiCheckbox: {
            root: {
                "&$checked": {
                    "& .MuiIconButton-label": {
                        position: "relative",
                        zIndex: 0
                    },
                    "& .MuiIconButton-label:after": {
                        content: '""',
                        left: 6,
                        top: 6,
                        height: 18,
                        width: 18,
                        position: "absolute",
                        backgroundColor: "black",
                        zIndex: -1
                    }
                },
                "& .MuiIconButton-label": {
                    position: "relative",
                    zIndex: 0,
                    color: '#dbdbdb'
                },
                "& .MuiIconButton-label:after": {
                    content: '""',
                    left: 6,
                    top: 6,
                    height: 19,
                    width: 19,
                    position: "absolute",
                    backgroundColor: "#dbdbdb",
                    zIndex: -1
                },
            }
        },
        MuiTypography: {
            body1: {
                fontSize: 18,
                /* color: '#333333' */
            }
        },
        MuiDialog: {
            paperWidthSm: {
                maxWidth: 460
            },

        },
        MuiDialogTitle: {
            root: {
                fontSize: 19,
                padding: '16px 32px',
            }
        },
        MuiDialogContent: {
            root: {

                padding: '16px 32px',
            }
        },
        MuiDialogActions: {
            root: {

                padding: '16px 32px',
            }
        },
        MuiAlert: {
            root: {
                padding: '6px 16px'
            },
            message:
            {
                padding: '5px 0px'
            },
            icon: {
                padding: '4px 0px'
            }
        },
        MuiSelect: {
            select: {
                '&:before': {
                    borderColor: '#000',
                },
                "&:focus": {

                    backgroundColor: 'transparent'
                },
                root: {
                    icon: {
                        color: "#000",
                        backgroundColor: "#000",
                    },
                    iconFilled: {
                        color: "#000",
                        backgroundColor: "#000",
                    },
                    iconOutlined: {
                        color: "#000",
                        backgroundColor: "#000",
                    },
                },
                icon: {
                    color: "#000",
                    backgroundColor: "#000",
                },
                iconFilled: {
                    color: "#000",
                    backgroundColor: "#000",
                },
                iconOutlined: {
                    color: "#000",
                    backgroundColor: "#000",
                },
               
            }
        },
       
        MuiRadio: {
            root: {
                "& .MuiSvgIcon-root": {
                    color: 'black'
                }
            }
        }
    }
});


export default theme;